import { QueryCreator } from 'kysely';
import { DatasetDatabase } from '../datasetQueryBuilder';
import { applyShiftPartitionFilter } from '../datasetQueryBuilder.helper';
import { DocumentBaseBaseQueryBuilderParams } from '../datasetQueryBuilder.types';

export function getAnalyzedJobEventQueryBuilder<T extends DatasetDatabase>(
  params: DocumentBaseBaseQueryBuilderParams,
  db: QueryCreator<T>,
) {
  const { documentContext } = params;
  let qb = db
    .selectFrom('___analyzed_job_event___')
    .where('documentId', '=', documentContext.documentId as any);

  qb = applyShiftPartitionFilter({
    qb,
    documentContext,
    field: 'eventDate',
  });

  return qb;
}
